import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags.tsx';
import { getEnvironment } from '@/utils';
import { AIChat } from './AIChat.tsx';

// immer für Dev und auf staging mit feature flag "ai"
export function AIChatGate() {
  if (import.meta.env.DEV) {
    return <AIChat />;
  }

  if (getEnvironment() === 'production') {
    return null;
  }

  return (
    <WithFeatureFlags name="ai" Fallback={<></>}>
      <AIChat />
    </WithFeatureFlags>
  );
}
